module.exports = require("core-js-pure/features/instance/index-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js
// module id = 2864
// module chunks = 25